import graphql__9e7df36a1c9d77e7a22e from "./__generated__/ParticipativeModuleVisualization_participativeModule.graphql.js";import { useFragment } from "react-relay";
import { graphql } from "react-relay";

import ContributionsListManager from "./Visualizations/ContributionsListManager";
import ContributionsGridManager from "./Visualizations/ContributionsGridManager";
import Survey from "./Visualizations/Survey";
import ContributionsDataviz from "./Visualizations/ContributionsDataviz/ContributionsDataviz";
import ContributionsMap from "./Visualizations/ContributionsMap/ContributionsMap";
import CityWalk from "../CityWalks/CityWalk";

const Visualizations = {
  ContributionsList: ContributionsListManager,
  ContributionsGrid: ContributionsGridManager,
  Survey: Survey,
  ContributionsDataviz: ContributionsDataviz,
  ContributionsMap: ContributionsMap,
  CityWalk: CityWalk
};

const ParticipativeModuleVisualization = props => {
  const participativeModule = useFragment(
    ParticipativeModuleVisualization_participativeModule,
    props.participativeModule
  );
  const { visualization } = participativeModule;

  const visualizationTypeName = participativeModule.visualization.__typename;
  const Visualization = Visualizations[visualizationTypeName];

  if (!Visualization) {
    throw new Error(
      `No ParticipativeModuleVisualization found for ${visualizationTypeName}`
    );
  }

  return (
    <Visualization
      participativeModuleId={participativeModule.id}
      visualization={visualization}
    />
  );
};

const ParticipativeModuleVisualization_participativeModule = graphql__9e7df36a1c9d77e7a22e;

export default ParticipativeModuleVisualization;
